import { SubscriptionType } from "~/types/subscription/subscription.types";

export const subscriptionTypeToName: { [key in SubscriptionType]: string } = {
  MEMBER: "Member",
  MEMBER_PLUS: "Member Plus",
  REDUCED_MEMBER: "Reduced Member",
  REDUCED_SPECIAL: "Reduced Special",
  SPECIAL: "Special",
};
